<div class="multiple-x-chart" [id]="chartDimensions.chartConfig.elementId"></div>
